"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var rich_text_from_markdown_1 = require("@contentful/rich-text-from-markdown");
var react_1 = require("react");
var RichText_1 = require("../RichTextEditor/RichText");
var Markdown = function (_a) {
    var content = _a.content, style = _a.style;
    var _b = (0, react_1.useState)({}), richContent = _b[0], setRichContent = _b[1];
    (0, react_1.useEffect)(function () {
        (0, rich_text_from_markdown_1.richTextFromMarkdown)(content).then(function (data) {
            setRichContent(data);
        });
    }, [content]);
    return (0, jsx_runtime_1.jsx)(RichText_1.default, { data: richContent, style: style });
};
exports.default = Markdown;
